var _effectorFileName = "/builds/gmini/front-ui-kit/src/IconButton/IconButton.styled.ts";
import styled, { css } from 'styled-components';
export const IconButtonStyled = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: max-content;
  width: max-content;
  position: relative;
  border: none;
  cursor: pointer;
  background: transparent;
  border-radius: 4px;
  transition: all 0.2s ease-out;
  padding: ${props => props.size === 'xs' ? '0' : props.size === 'small' ? '4px' : '6px'};
  ${props => props.isCircle && 'border-radius: 50%;'}
  ${props => props.active && 'background: rgba(53, 59, 96, 0.2);'}
  ${props => props.selected && 'background: #4C5ECF;'}

  & svg {
    ${props => props.size === 'xs' ? css`
            width: 20px;
            min-width: 20px;
            height: 20px;
            min-height: 20px;
          ` : css`
            width: 24px;
            min-width: 24px;
            height: 24px;
            min-height: 24px;
          `}
  }

  path {
    transition: all 0.2s ease-out;
  }

  path[fill] {
    fill: rgba(53, 59, 96, 0.5);
    ${props => props.selected && 'fill: #fff;'};
  }

  path[stroke] {
    stroke: rgba(53, 59, 96, 0.5);
    ${props => props.selected && 'stroke: #fff;'};
  }

  &:hover {
    background: ${props => props.selected ? '#2235AA' : 'rgba(53, 59, 96, 0.1)'};
  }

  &:active {
    ${props => !props.selected && 'background: rgba(53, 59, 96, 0.2)'}
  }

  &:disabled {
    pointer-events: none;
    background: inherit;
    cursor: default;

    path[fill] {
      fill: rgba(53, 59, 96, 0.15);
    }

    path[stroke] {
      stroke: rgba(53, 59, 96, 0.15);
    }
  }
`;
export const WarningButton = styled(IconButtonStyled)`
  ${props => props.selected ? 'background: rgb(217, 87, 94);' : ''}

  & path {
    fill: ${props => props.selected ? '#fff' : 'rgb(217, 87, 94)'};
  }

  & path[fill] {
    fill: ${props => props.selected ? '#fff' : 'rgb(217, 87, 94)'};
  }

  & path[stroke] {
    stroke: ${props => props.selected ? '#fff' : 'rgb(217, 87, 94)'};
  }

  &:hover {
    ${props => props.selected ? 'background: rgb(191, 55, 55);' : ''}
  }

  &:active {
    ${props => props.selected ? 'background: rgb(217, 87, 94);' : ''}
  }
`;